export default (
  <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" fill="#00C6A9" />
    <path d="M7 8h2v3.5h4V8h2v8h-2v-3H9v3H7V8z" fill="#ffffff" />
  </svg>
);
